export default "__VITE_ASSET__BxQ7zHGN__"